var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOverlayDots = function SvgOverlayDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 243,
    height: 243,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.628,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.335,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.905,
    cy: 2.095,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.63,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.337,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.903,
    cy: 14.663,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.628,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.335,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.905,
    cy: 27.232,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.628,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.335,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.905,
    cy: 39.802,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.63,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.337,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.903,
    cy: 52.37,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.628,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.335,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.905,
    cy: 64.939,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.628,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.335,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.905,
    cy: 77.509,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.63,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.337,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.903,
    cy: 90.077,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.628,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.335,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.905,
    cy: 102.646,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.628,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.335,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.905,
    cy: 115.216,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.63,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.337,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.903,
    cy: 127.784,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.628,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.335,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.905,
    cy: 140.353,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.628,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.335,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.905,
    cy: 152.923,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.63,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.337,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.903,
    cy: 165.491,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.628,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.335,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.905,
    cy: 178.06,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.63,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.337,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.903,
    cy: 190.63,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.63,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.337,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.903,
    cy: 203.198,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.628,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.335,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.905,
    cy: 215.767,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.63,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.337,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.903,
    cy: 228.335,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.663,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.233,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.802,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.37,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.939,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.509,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.077,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.646,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.216,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.784,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.353,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.921,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.491,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.06,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.63,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.198,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.767,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.337,
    cy: 240.905,
    r: 2.095
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.903,
    cy: 240.905,
    r: 2.095
  }))));
};
export default SvgOverlayDots;